import { connect } from "react-redux";
import {
    createAccountNote,
    getAccountNoteList,
    removeAccountNote
} from "actions/account_note";

import Notes from "./Notes";


const mapState = ({ account_note }) => ({
    notesList: account_note.list,
    notesLoading: account_note.loading,
    isFetched: account_note.isFetched,
});

export default connect(mapState, {
    getAccountNoteList,
    removeAccountNote,
    createAccountNote,
})(Notes);